import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Typography, Divider, Grid } from '@material-ui/core';
import PageTitle from '../../components/ui/PageTitleUI';
import ButtonUI from '../../components/ui/ButtonUI';
import { useTranslation } from 'react-i18next';
import {
    Search as SearchIcon,
    BackspaceOutlined as BackspaceOutlinedIcon
} from '@material-ui/icons';
import { useAuth } from '../../hooks/auth';
import { useForm } from 'react-hook-form';
import TextField from '../../components/Form/TextField';
import DateField from '../../components/Form/Date';
import { useStyles } from '../../utils/DefaultStyles';
import SelectSupplier from '../../components/Form/SelectSupplier';
import ReportApi from '../../services/ReportApi';
import permissions from '../../utils/Permissions';
import * as Yup from 'yup'
import { useSnackbar } from 'notistack';
import { YupValidateNullableNumber, YupValidation } from '../../utils/componentUtils';
import Select from '../../components/Form/Select';

const BusinessSecurity: React.FC = () => {
    const classes = useStyles();
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Reports");
    const { t: tval } = useTranslation("Validation");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (!hasPermission(permissions.REPORTS.BusinessSecurity))
           history.replace('/NoPermission');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, user]);

    
    //Campos do Form
    interface IFormPanel {
        entranceDateStart: Date | null;
        entranceDateEnd: Date | null;
        exitDateStart: Date | null;
        exitDateEnd: Date | null;
        mvmNumber: any;
        vehiclePlateNumber: any;
        suppliers: any;
        renderType: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, clearErrors, setError } = useForm<IFormPanel>({
        defaultValues: {
            entranceDateStart: null,
            entranceDateEnd: null,
            exitDateStart: null,
            exitDateEnd: null,
            mvmNumber: '',
            vehiclePlateNumber: '',
            suppliers: [],
            renderType: {code: '2', label: 'Excel'}
        }
    });

    const onSubmit = async (data: any) => {
        var validForm = await formValidation(data);
        if (validForm === false)
            return;
        
        data.supplierNames = data.suppliers.map((x:any) => (x.code + ' - ' + x.name));
        data.supplierIds = data.suppliers.map((x:any) => (x.code));
        data.companyId = user.company.companyID;
        data.userName = user.name;
        data.renderType = data.renderType.code;

        ReportApi.printBusinessSecurity(data);
    };

    const cleanFilters = () => {
        reset();
    };

    

    const formValidation = async (data: any) => {
        
        const schema = Yup.object().shape({
            mvmNumber: Yup.number().nullable(true).typeError(tval("mustBeNumber")).transform(YupValidateNullableNumber), //transformar valor vazio em null
            entranceDateStart: Yup.date().nullable().typeError(tval("formatDate")),
            entranceDateEnd: Yup.date().nullable().typeError(tval("formatDate")),
            exitDateStart: Yup.date().nullable().typeError(tval("formatDate")),
            exitDateEnd: Yup.date().nullable().typeError(tval("formatDate"))
        });

        return await YupValidation(data, schema, tval, false, enqueueSnackbar, clearErrors, setError);
    }

    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={t("pageTitle") + t("businessSecurity.pageTitle")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleParameters")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI onClick={() => cleanFilters()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{_t("export")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={3}>
                                <SelectSupplier
                                    label={t("businessSecurity.supplier")} 
                                    name="suppliers" 
                                    control={control} 
                                    multiple={true}
                                    fullWidth
                                    // style={{width: '100%'}}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("businessSecurity.entranceDateStart")} name="entranceDateStart" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("businessSecurity.entranceDateEnd")} name="entranceDateEnd" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("businessSecurity.exitDateStart")} name="exitDateStart" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <DateField label={t("businessSecurity.exitDateEnd")} name="exitDateEnd" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>
                            </Grid>
                            <Grid container spacing={1}>

                            <Grid item xs={3}>
                                <TextField inputProps={{maxLength: 10}} label={t("businessSecurity.mvmNumber")} name="mvmNumber" control={control} InputLabelProps={{shrink:true}} fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("businessSecurity.vehiclePlateNumber")} name="vehiclePlateNumber" control={control} InputLabelProps={{shrink:true}} mask="aaa9*99" fullWidth/>
                            </Grid>


                            <Grid item xs={1}>
                                <Select
                                    label={_t("reportExportType")} 
                                    name="renderType"
                                    control={control} 
                                    options={[{code: '2', label: 'Excel'}, {code: '1', label: 'PDF'}]}
                                    style={{width: '100%'}}/>
                            </Grid>
                        </Grid>
                    </form>

                </div>
            </div>
        </Container>
    )
}
export default BusinessSecurity;
